class SingleNews {
  constructor(el) {
    this.el = el;

    if (!document.querySelector('.' + this.el)) {
      return;
    }

    this.initScrollHint();
  }

  initScrollHint() {
    const scrollables = document.querySelectorAll('.' + this.el + ' .js-news-table-scroll');

    if (!scrollables.length || typeof ScrollHint === 'undefined') {
      return;
    }

    const mq = window.matchMedia('(max-width: 767px)');

    if (!mq.matches) {
      return;
    }

    if (this.scrollHintInited) {
      return;
    }

    this.scrollHintInited = true;

    new ScrollHint('.' + this.el + ' .js-news-table-scroll', {
      suggestiveShadow: true,
      scrollHintIconAppendClass: 'scroll-hint-icon-white',
      i18n: {
        scrollable: 'スクロールできます',
      },
    });
  }
}
